<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite }, query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Observaciones Codificadas — Trámite N.° {{ p_idtramite }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <div v-else>

      <!-- Tarjetas resumen -->
      <div class="mb-4">
        <div class="d-flex justify-content-between align-items-stretch flex-wrap gap-3">
          <div class="d-flex gap-3">
            <div class="card border-0 shadow-sm h-100 px-3 py-2 text-center d-flex flex-column justify-content-center align-items-center"
                 style="min-width: 140px;">
              <div class="small text-muted fw-bold d-flex align-items-center justify-content-center gap-1 mb-1">
                <span class="material-symbols-outlined" style="font-size:16px">description</span>
                <span>Planillas con obs.</span>
              </div>
              <div class="fs-4 fw-bold text-primary lh-1">{{ planillasFiltradas.length }}</div>
            </div>
            <div class="card border-0 shadow-sm h-100 px-3 py-2 text-center d-flex flex-column justify-content-center align-items-center"
                 style="min-width: 140px;">
              <div class="small text-muted fw-bold d-flex align-items-center justify-content-center gap-1 mb-1">
                <span class="material-symbols-outlined" style="font-size:16px">list</span>
                <span>Detalles con obs.</span>
              </div>
              <div class="fs-4 fw-bold text-primary lh-1">{{ detsFiltrados.length }}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <span class="small text-muted fst-italic mb-1 text-end">
              Resumen — {{ activeTab === 'planilla' ? 'Planilla' : 'Detalle' }}
            </span>
            <div class="d-flex gap-3 flex-grow-1">
              <div class="card border-0 shadow-sm px-3 py-2 text-center d-flex flex-column justify-content-center align-items-center"
                   style="min-width: 130px;">
                <div class="small text-muted fw-bold mb-1">Justificada</div>
                <div class="fs-4 fw-bold text-warning lh-1">{{ justificadasActual }}</div>
              </div>
              <div class="card border-0 shadow-sm px-3 py-2 text-center d-flex flex-column justify-content-center align-items-center"
                   style="min-width: 150px;">
                <div class="small text-muted fw-bold mb-1">Se acepta objeción</div>
                <div class="fs-4 fw-bold text-success lh-1">{{ aceptadasActual }}</div>
              </div>
              <div class="card border-0 shadow-sm px-3 py-2 text-center d-flex flex-column justify-content-center align-items-center"
                   style="min-width: 130px; cursor:pointer;"
                   :class="{ 'border border-danger': (activeTab === 'planilla' ? soloPendientesPla : soloPendientesDet) }"
                   title="Clic para filtrar solo pendientes"
                   @click="activeTab === 'planilla' ? (soloPendientesPla = !soloPendientesPla) : (soloPendientesDet = !soloPendientesDet)">
                <div class="small text-muted fw-bold mb-1">Pendientes</div>
                <div class="fs-4 fw-bold text-danger lh-1">
                  {{ activeTab === 'planilla' ? pendientesPla : pendientesDet }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'planilla' }"
             href="#" @click.prevent="activeTab = 'planilla'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">description</span>
            Planilla
            <span class="badge bg-primary ms-1">{{ planillasFiltradas.length }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'detalle' }"
             href="#" @click.prevent="activeTab = 'detalle'">
            <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">list</span>
            Detalle
            <span class="badge bg-primary ms-1">{{ detsFiltrados.length }}</span>
          </a>
        </li>
      </ul>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Planilla                                       -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'planilla'">
        <!-- Barra de acciones -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <label class="form-label mb-0 small fw-bold">Mostrar</label>
            <select v-model.number="itemsPerPagePla" class="form-select form-select-sm"
                    style="width: 75px" @change="paginaPla = 1">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
            <span class="small text-muted">registros</span>
            <button class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                    :disabled="cargando" @click="cargarDatos">
              <span class="material-symbols-outlined" style="font-size:16px">refresh</span>
              {{ cargando ? 'Cargando...' : 'Recargar' }}
            </button>
            <div class="form-check form-check-inline mb-0">
              <input class="form-check-input" type="checkbox" id="soloPendientesPla"
                     v-model="soloPendientesPla" @change="paginaPla = 1" />
              <label class="form-check-label small fw-bold" for="soloPendientesPla">Solo pendientes</label>
            </div>
            <button v-if="hayFiltrosPla"
                    class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
                    @click="limpiarFiltrosPla">
              <span class="material-symbols-outlined" style="font-size:16px">filter_alt_off</span>
              Limpiar filtros
            </button>
            <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
                    @click="exportarExcelPlanillas"
                    :disabled="planillasFiltradas.length === 0">
              <span class="material-icons" style="font-size:16px">table_view</span> Excel
            </button>
            <button v-if="seleccionadosPla.length > 0"
                    class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                    @click="abrirModalMasivo('planilla')">
              <span class="material-symbols-outlined" style="font-size:16px">edit_note</span>
              Responder seleccionados ({{ seleccionadosPla.length }})
            </button>
          </div>
          <input v-model="filtroPla" class="form-control form-control-sm"
                 style="width: 220px" placeholder="🔍 Buscar..." @input="paginaPla = 1" />
        </div>

        <div v-if="planillasFiltradas.length === 0" class="alert alert-warning">
          No se encontraron planillas con observaciones codificadas.
        </div>
        <div v-else>
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <!-- Fila 1: Encabezados -->
                <tr>
                  <th style="width:34px">
                    <input type="checkbox" title="Seleccionar todos los filtrados"
                           :checked="todosPlaFiltradosSeleccionados"
                           @change="toggleSeleccionarTodosPla" />
                  </th>
                  <th style="width:40px"></th>
                  <th class="th-sort" @click="ordenarPla('numero')">N.° <span>{{ iconPla('numero') }}</span></th>
                  <th class="th-sort" @click="ordenarPla('cedula')">Cédula <span>{{ iconPla('cedula') }}</span></th>
                  <th class="th-sort" @click="ordenarPla('nombre')">Nombre <span>{{ iconPla('nombre') }}</span></th>
                  <th class="th-sort" @click="ordenarPla('diag1')">Diag. 1 <span>{{ iconPla('diag1') }}</span></th>
                  <th class="th-sort" @click="ordenarPla('diag2')">Diag. 2 <span>{{ iconPla('diag2') }}</span></th>
                  <th class="th-obs bg-info bg-opacity-25">Obs. GD (Cód.)</th>
                  <th class="th-obs bg-info bg-opacity-25">Obs. GD (Comp.)</th>
                  <th class="th-obs bg-warning bg-opacity-25">Obs. AM (Cód.)</th>
                  <th class="th-obs bg-warning bg-opacity-25">Obs. AM (Comp.)</th>
                  <th class="th-obs bg-success bg-opacity-25">Obs. CT (Cód.)</th>
                  <th class="th-obs bg-success bg-opacity-25">Obs. CT (Comp.)</th>
                  <th class="th-sort" @click="ordenarPla('resolucion')">Resolución <span>{{ iconPla('resolucion') }}</span></th>
                  <th class="th-obs bg-info bg-opacity-10">Resp. GD</th>
                  <th class="th-obs bg-info bg-opacity-10" style="width:70px">
                    <span title="Estado respuesta GD">✓ GD</span>
                  </th>
                  <th class="th-obs bg-warning bg-opacity-10">Resp. AM</th>
                  <th class="th-obs bg-warning bg-opacity-10" style="width:70px">
                    <span title="Estado respuesta AM">✓ AM</span>
                  </th>
                  <th class="th-obs bg-success bg-opacity-10">Resp. CT</th>
                  <th class="th-obs bg-success bg-opacity-10" style="width:70px">
                    <span title="Estado respuesta CT">✓ CT</span>
                  </th>
                </tr>
                <!-- Fila 2: Filtros -->
                <tr>
                  <th></th> <!-- checkbox: sin filtro -->
                  <th></th> <!-- columna abrir: sin filtro -->
                  <th><input v-model="filtrosPla.numero"   @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosPla.cedula"   @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosPla.nombre"   @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosPla.diag1" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option v-for="d in diagsPla1" :key="d" :value="d">{{ d }}</option>
                    </select>
                  </th>
                  <th>
                    <select v-model="filtrosPla.diag2" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option v-for="d in diagsPla2" :key="d" :value="d">{{ d }}</option>
                    </select>
                  </th>
                  <!-- Obs. GD codificada: select -->
                  <th>
                    <select v-model="filtrosPla.obsCodGD" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsPla.obsCodGD" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. GD complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosPla.obsCompGD" list="dlPlaObsCompGD"
                           @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlPlaObsCompGD">
                      <option v-for="v in opcionesObsPla.obsCompGD" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <!-- Obs. AM codificada: select -->
                  <th>
                    <select v-model="filtrosPla.obsCodAM" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsPla.obsCodAM" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. AM complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosPla.obsCompAM" list="dlPlaObsCompAM"
                           @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlPlaObsCompAM">
                      <option v-for="v in opcionesObsPla.obsCompAM" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <!-- Obs. CT codificada: select -->
                  <th>
                    <select v-model="filtrosPla.obsCodCT" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsPla.obsCodCT" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. CT complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosPla.obsCompCT" list="dlPlaObsCompCT"
                           @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlPlaObsCompCT">
                      <option v-for="v in opcionesObsPla.obsCompCT" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <th>
                    <select v-model="filtrosPla.resolucion" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option value="SE ACEPTA OBJECIÓN">Se acepta</option>
                      <option value="JUSTIFICADA">Justificada</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosPla.respuestaGD" @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosPla.estadoRespGD" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosPla.respuestaAM" @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosPla.estadoRespAM" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosPla.respuestaCT" @input="paginaPla=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosPla.estadoRespCT" @change="paginaPla=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in pagedPla" :key="r.idPlanilla"
                    @dblclick="abrirModal('planilla', r)" title="Doble clic para registrar respuesta">
                  <td class="text-center" @dblclick.stop>
                    <input type="checkbox"
                           :checked="seleccionadosPla.includes(r.idPlanilla)"
                           @change="toggleSeleccionPla(r.idPlanilla)" />
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary" @click.stop="abrirPlanilla(r.idPlanilla)" title="Abrir planilla">
                      <span class="material-icons" style="font-size:14px">open_in_new</span>
                    </button>
                  </td>
                  <td>{{ r.numero }}</td>
                  <td>{{ r.cedula }}</td>
                  <td>{{ r.nombre }}</td>
                  <td>{{ r.diag1 }}</td>
                  <td>{{ r.diag2 }}</td>
                  <td>{{ r.obsCodificadaGD }}</td>
                  <td>{{ r.obsComplementariaGD }}</td>
                  <td>{{ r.obsCodificadaAM }}</td>
                  <td>{{ r.obsComplementariaAM }}</td>
                  <td>{{ r.obsCodificadaCT }}</td>
                  <td>{{ r.obsComplementariaCT }}</td>
                  <td>
                    <span :class="r.resolucion === 'SE ACEPTA OBJECIÓN' ? 'badge bg-success' : 'badge bg-warning text-dark'">
                      {{ r.resolucion || '—' }}
                    </span>
                  </td>
                  <td>{{ r.respuestaGD || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaGD" class="material-icons text-info" style="font-size:16px" title="Con respuesta GD">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta GD">radio_button_unchecked</span>
                  </td>
                  <td>{{ r.respuestaAM || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaAM" class="material-icons text-warning" style="font-size:16px" title="Con respuesta AM">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta AM">radio_button_unchecked</span>
                  </td>
                  <td>{{ r.respuestaCT || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaCT" class="material-icons text-success" style="font-size:16px" title="Con respuesta CT">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta CT">radio_button_unchecked</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary">
                  <td colspan="20" class="text-end fw-bold small">
                    Mostrando {{ pagedPla.length }} de {{ planillasFiltradas.length }} registros
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Paginación planilla -->
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">
              Página {{ paginaPla }} de {{ totalPagesPla }} — {{ planillasFiltradas.length }} registros
            </span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaPla === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaPla = 1">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaPla === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaPla--">‹</a>
                </li>
                <li v-for="p in paginasVisibles(paginaPla, totalPagesPla)" :key="p"
                    class="page-item" :class="{ active: p === paginaPla, disabled: p === '...' }">
                  <a class="page-link" href="#" @click.prevent="p !== '...' && (paginaPla = p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaPla === totalPagesPla }">
                  <a class="page-link" href="#" @click.prevent="paginaPla++">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaPla === totalPagesPla }">
                  <a class="page-link" href="#" @click.prevent="paginaPla = totalPagesPla">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Detalle                                        -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'detalle'">
        <!-- Barra de acciones -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <label class="form-label mb-0 small fw-bold">Mostrar</label>
            <select v-model.number="itemsPerPageDet" class="form-select form-select-sm"
                    style="width: 75px" @change="paginaDet = 1">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
            <span class="small text-muted">registros</span>
            <button class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                    :disabled="cargando" @click="cargarDatos">
              <span class="material-symbols-outlined" style="font-size:16px">refresh</span>
              {{ cargando ? 'Cargando...' : 'Recargar' }}
            </button>
            <div class="form-check form-check-inline mb-0">
              <input class="form-check-input" type="checkbox" id="soloPendientesDet"
                     v-model="soloPendientesDet" @change="paginaDet = 1" />
              <label class="form-check-label small fw-bold" for="soloPendientesDet">Solo pendientes</label>
            </div>
            <button v-if="hayFiltrosDet"
                    class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
                    @click="limpiarFiltrosDet">
              <span class="material-symbols-outlined" style="font-size:16px">filter_alt_off</span>
              Limpiar filtros
            </button>
            <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
                    @click="exportarExcelDetalles"
                    :disabled="detsFiltrados.length === 0">
              <span class="material-icons" style="font-size:16px">table_view</span> Excel
            </button>
            <button v-if="seleccionadosDet.length > 0"
                    class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                    @click="abrirModalMasivo('detalle')">
              <span class="material-symbols-outlined" style="font-size:16px">edit_note</span>
              Responder seleccionados ({{ seleccionadosDet.length }})
            </button>
          </div>
          <input v-model="filtroDet" class="form-control form-control-sm"
                 style="width: 220px" placeholder="🔍 Buscar..." @input="paginaDet = 1" />
        </div>

        <div v-if="detsFiltrados.length === 0" class="alert alert-warning">
          No se encontraron detalles con observaciones codificadas.
        </div>
        <div v-else>
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <!-- Fila 1: Encabezados -->
                <tr>
                  <th style="width:34px">
                    <input type="checkbox" title="Seleccionar todos los filtrados"
                           :checked="todosDetFiltradosSeleccionados"
                           @change="toggleSeleccionarTodosDet" />
                  </th>
                  <th style="width:40px"></th>
                  <th class="th-sort" @click="ordenarDet('numeroInt')">N.° <span>{{ iconDet('numeroInt') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('planillaCedula')">Cédula <span>{{ iconDet('planillaCedula') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('planillaNombre')">Nombre <span>{{ iconDet('planillaNombre') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('elementoCodigo')">Código <span>{{ iconDet('elementoCodigo') }}</span></th>
                  <th class="th-sort" @click="ordenarDet('elementoNombre')">Nombre elemento <span>{{ iconDet('elementoNombre') }}</span></th>
                  <th class="th-obs bg-info bg-opacity-25">Obs. GD (Cód.)</th>
                  <th class="th-obs bg-info bg-opacity-25">Obs. GD (Comp.)</th>
                  <th class="th-obs bg-warning bg-opacity-25">Obs. AM (Cód.)</th>
                  <th class="th-obs bg-warning bg-opacity-25">Obs. AM (Comp.)</th>
                  <th class="th-obs bg-success bg-opacity-25">Obs. CT (Cód.)</th>
                  <th class="th-obs bg-success bg-opacity-25">Obs. CT (Comp.)</th>
                  <th class="th-sort" @click="ordenarDet('resolucion')">Resolución <span>{{ iconDet('resolucion') }}</span></th>
                  <th class="th-obs bg-info bg-opacity-10">Resp. GD</th>
                  <th class="th-obs bg-info bg-opacity-10" style="width:70px"><span title="Estado respuesta GD">✓ GD</span></th>
                  <th class="th-obs bg-warning bg-opacity-10">Resp. AM</th>
                  <th class="th-obs bg-warning bg-opacity-10" style="width:70px"><span title="Estado respuesta AM">✓ AM</span></th>
                  <th class="th-obs bg-success bg-opacity-10">Resp. CT</th>
                  <th class="th-obs bg-success bg-opacity-10" style="width:70px"><span title="Estado respuesta CT">✓ CT</span></th>
                </tr>
                <!-- Fila 2: Filtros -->
                <tr>
                  <th></th> <!-- checkbox: sin filtro -->
                  <th></th> <!-- columna abrir: sin filtro -->
                  <th><input v-model="filtrosDet.numeroInt"    @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.cedula"       @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th><input v-model="filtrosDet.nombre"       @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosDet.codigo" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option v-for="c in codigosDet" :key="c" :value="c">{{ c }}</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosDet.elementoNombre" @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <!-- Obs. GD codificada: select -->
                  <th>
                    <select v-model="filtrosDet.obsCodGD" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsDet.obsCodGD" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. GD complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosDet.obsCompGD" list="dlDetObsCompGD"
                           @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlDetObsCompGD">
                      <option v-for="v in opcionesObsDet.obsCompGD" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <!-- Obs. AM codificada: select -->
                  <th>
                    <select v-model="filtrosDet.obsCodAM" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsDet.obsCodAM" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. AM complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosDet.obsCompAM" list="dlDetObsCompAM"
                           @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlDetObsCompAM">
                      <option v-for="v in opcionesObsDet.obsCompAM" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <!-- Obs. CT codificada: select -->
                  <th>
                    <select v-model="filtrosDet.obsCodCT" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option v-for="v in opcionesObsDet.obsCodCT" :key="v" :value="v">{{ v }}</option>
                    </select>
                  </th>
                  <!-- Obs. CT complementaria: input + datalist -->
                  <th>
                    <input v-model="filtrosDet.obsCompCT" list="dlDetObsCompCT"
                           @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." />
                    <datalist id="dlDetObsCompCT">
                      <option v-for="v in opcionesObsDet.obsCompCT" :key="v" :value="v" />
                    </datalist>
                  </th>
                  <th>
                    <select v-model="filtrosDet.resolucion" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todas</option>
                      <option value="SE ACEPTA OBJECIÓN">Se acepta</option>
                      <option value="JUSTIFICADA">Justificada</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosDet.respuestaGD" @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosDet.estadoRespGD" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosDet.respuestaAM" @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosDet.estadoRespAM" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                  <th><input v-model="filtrosDet.respuestaCT" @input="paginaDet=1" class="form-control form-control-sm" placeholder="Filtrar..." /></th>
                  <th>
                    <select v-model="filtrosDet.estadoRespCT" @change="paginaDet=1" class="form-select form-select-sm">
                      <option value="">Todos</option>
                      <option value="con">Con resp.</option>
                      <option value="sin">Sin resp.</option>
                    </select>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in pagedDet" :key="r.idPlanillaDet"
                    @dblclick="abrirModal('detalle', r)" title="Doble clic para registrar respuesta">
                  <td class="text-center" @dblclick.stop>
                    <input type="checkbox"
                           :checked="seleccionadosDet.includes(r.idPlanillaDet)"
                           @change="toggleSeleccionDet(r.idPlanillaDet)" />
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary" @click.stop="abrirPlanilla(r.idPlanilla)" title="Abrir planilla">
                      <span class="material-icons" style="font-size:14px">open_in_new</span>
                    </button>
                  </td>
                  <td>{{ r.numeroInt }}</td>
                  <td>{{ r.planillaCedula }}</td>
                  <td>{{ r.planillaNombre }}</td>
                  <td><code>{{ r.elementoCodigo }}</code></td>
                  <td>{{ r.elementoNombre }}</td>
                  <td>{{ r.obsCodificadaGD }}</td>
                  <td>{{ r.obsComplementariaGD }}</td>
                  <td>{{ r.obsCodificadaAM }}</td>
                  <td>{{ r.obsComplementariaAM }}</td>
                  <td>{{ r.obsCodificadaCT }}</td>
                  <td>{{ r.obsComplementariaCT }}</td>
                  <td>
                    <span :class="r.resolucion === 'SE ACEPTA OBJECIÓN' ? 'badge bg-success' : 'badge bg-warning text-dark'">
                      {{ r.resolucion || '—' }}
                    </span>
                  </td>
                  <td>{{ r.respuestaGD || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaGD" class="material-icons text-info" style="font-size:16px" title="Con respuesta GD">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta GD">radio_button_unchecked</span>
                  </td>
                  <td>{{ r.respuestaAM || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaAM" class="material-icons text-warning" style="font-size:16px" title="Con respuesta AM">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta AM">radio_button_unchecked</span>
                  </td>
                  <td>{{ r.respuestaCT || '—' }}</td>
                  <td class="text-center">
                    <span v-if="r.respuestaCT" class="material-icons text-success" style="font-size:16px" title="Con respuesta CT">check_circle</span>
                    <span v-else class="material-icons text-muted" style="font-size:16px" title="Sin respuesta CT">radio_button_unchecked</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary">
                  <td colspan="20" class="text-end fw-bold small">
                    Mostrando {{ pagedDet.length }} de {{ detsFiltrados.length }} registros
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Paginación detalle -->
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">
              Página {{ paginaDet }} de {{ totalPagesDet }} — {{ detsFiltrados.length }} registros
            </span>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: paginaDet === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDet = 1">«</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === 1 }">
                  <a class="page-link" href="#" @click.prevent="paginaDet--">‹</a>
                </li>
                <li v-for="p in paginasVisibles(paginaDet, totalPagesDet)" :key="p"
                    class="page-item" :class="{ active: p === paginaDet, disabled: p === '...' }">
                  <a class="page-link" href="#" @click.prevent="p !== '...' && (paginaDet = p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === totalPagesDet }">
                  <a class="page-link" href="#" @click.prevent="paginaDet++">›</a>
                </li>
                <li class="page-item" :class="{ disabled: paginaDet === totalPagesDet }">
                  <a class="page-link" href="#" @click.prevent="paginaDet = totalPagesDet">»</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal respuesta individual -->
    <div v-if="modalVisible" class="modal fade show d-block" tabindex="-1"
         style="background: rgba(0,0,0,0.5)" @click.self="cerrarModal">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white py-2">
            <span class="material-symbols-outlined me-2">edit_note</span>
            <h6 class="modal-title mb-0">
              Respuesta —
              {{ modalTipo === 'planilla' ? 'Planilla N.° ' + modalDato.numero : 'Detalle N.° ' + modalDato.numeroInt }}
            </h6>
            <button type="button" class="btn-close btn-close-white ms-auto" @click="cerrarModal"></button>
          </div>
          <div class="modal-body" style="background-color: #f0f2f5;">
            <div class="alert alert-secondary py-2 px-3 small mb-3">
              <span class="fw-bold">Cédula:</span> {{ modalDato.cedula || modalDato.planillaCedula }}
              &nbsp;|&nbsp;
              <span class="fw-bold">Nombre:</span> {{ modalDato.nombre || modalDato.planillaNombre }}
              <template v-if="modalTipo === 'detalle'">
                &nbsp;|&nbsp;
                <span class="fw-bold">Código:</span> {{ modalDato.elementoCodigo }}
                &nbsp;|&nbsp;
                <span class="fw-bold">Descripción:</span> {{ modalDato.elementoNombre }}
              </template>
            </div>
            <div class="mb-3 d-flex align-items-center justify-content-between w-100 py-2 px-4 bg-light border rounded">
              <div class="d-flex align-items-center flex-shrink-0" style="gap: 0.5rem;">
                <input type="checkbox" id="resolucionCheck" v-model="modalForm.resolucion"
                       style="width: 1rem; height: 1rem; margin: 0;" />
                <label class="fw-bold mb-0" for="resolucionCheck" style="white-space: nowrap;">Aceptar objeción</label>
              </div>
              <span class="small fw-bold" style="white-space: nowrap;">
                {{ modalForm.resolucion ? 'SE ACEPTA OBJECIÓN' : 'JUSTIFICADA' }}
              </span>
            </div>
            <ul class="nav nav-tabs mb-3">
              <li class="nav-item" v-if="tabsDisponibles.gd">
                <a class="nav-link" :class="{ active: modalTab === 'gd' }" href="#" @click.prevent="modalTab = 'gd'">
                  <span class="fw-bold text-info">GD</span>&nbsp; Gestión Documental
                </a>
              </li>
              <li class="nav-item" v-if="tabsDisponibles.am">
                <a class="nav-link" :class="{ active: modalTab === 'am' }" href="#" @click.prevent="modalTab = 'am'">
                  <span class="fw-bold text-warning">AM</span>&nbsp; Auditoría Médica
                </a>
              </li>
              <li class="nav-item" v-if="tabsDisponibles.ct">
                <a class="nav-link" :class="{ active: modalTab === 'ct' }" href="#" @click.prevent="modalTab = 'ct'">
                  <span class="fw-bold text-success">CT</span>&nbsp; Control de Tarifas
                </a>
              </li>
            </ul>
            <div v-if="modalTab === 'gd'">
              <div class="mb-3">
                <label class="form-label small fw-bold text-info">Obs. GD codificada</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsCodificadaGD || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label small fw-bold text-info">Obs. GD complementaria</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsComplementariaGD || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold text-info">Respuesta GD</label>
                <textarea v-model="modalForm.respuestaGD" class="form-control" rows="4" style="text-transform: uppercase"></textarea>
              </div>
            </div>
            <div v-if="modalTab === 'am'">
              <div class="mb-3">
                <label class="form-label small fw-bold text-warning">Obs. AM codificada</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsCodificadaAM || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label small fw-bold text-warning">Obs. AM complementaria</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsComplementariaAM || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold text-warning">Respuesta AM</label>
                <textarea v-model="modalForm.respuestaAM" class="form-control" rows="4" style="text-transform: uppercase"></textarea>
              </div>
            </div>
            <div v-if="modalTab === 'ct'">
              <div class="mb-3">
                <label class="form-label small fw-bold text-success">Obs. CT codificada</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsCodificadaCT || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label small fw-bold text-success">Obs. CT complementaria</label>
                <p class="form-control-plaintext border-bottom pb-1 small">{{ modalForm.obsComplementariaCT || '—' }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold text-success">Respuesta CT</label>
                <textarea v-model="modalForm.respuestaCT" class="form-control" rows="4" style="text-transform: uppercase"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-secondary btn-sm" @click="cerrarModal">Cancelar</button>
            <button type="button" class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                    @click="guardarRespuesta" :disabled="guardando">
              <span class="material-icons" style="font-size:16px">save</span>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal respuesta masiva -->
    <div v-if="modalMasivoVisible" class="modal fade show d-block" tabindex="-1"
         style="background: rgba(0,0,0,0.5)" @click.self="cerrarModalMasivo">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white py-2">
            <span class="material-symbols-outlined me-2">edit_note</span>
            <h6 class="modal-title mb-0">
              Respuesta masiva —
              {{ modalMasivoTipo === 'planilla' ? filasSeleccionadasPla.length : filasSeleccionadasDet.length }}
              registro(s) seleccionado(s)
            </h6>
            <button type="button" class="btn-close btn-close-white ms-auto" @click="cerrarModalMasivo"></button>
          </div>
          <div class="modal-body" style="background-color: #f0f2f5;">
            <div class="alert alert-warning py-2 px-3 small mb-3">
              <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">info</span>
              La respuesta que escribas se aplicará <strong>solo</strong> a los registros seleccionados que tengan
              observación en esa pestaña (GD/AM/CT). Los campos que dejes vacíos no se modifican.
            </div>

            <div class="mb-3 d-flex align-items-center justify-content-between w-100 py-2 px-4 bg-light border rounded">
              <div class="d-flex align-items-center flex-shrink-0" style="gap: 0.5rem;">
                <input type="checkbox" id="resolucionMasivaCheck" v-model="modalMasivoForm.resolucion"
                       style="width: 1rem; height: 1rem; margin: 0;" />
                <label class="fw-bold mb-0" for="resolucionMasivaCheck" style="white-space: nowrap;">
                  Aceptar objeción (aplica a todos los seleccionados)
                </label>
              </div>
              <span class="small fw-bold" style="white-space: nowrap;">
                {{ modalMasivoForm.resolucion ? 'SE ACEPTA OBJECIÓN' : 'JUSTIFICADA' }}
              </span>
            </div>

            <ul class="nav nav-tabs mb-3">
              <li class="nav-item" v-if="tabsDisponiblesMasivo.gd">
                <a class="nav-link" :class="{ active: modalMasivoTab === 'gd' }" href="#" @click.prevent="modalMasivoTab = 'gd'">
                  <span class="fw-bold text-info">GD</span>&nbsp; Gestión Documental
                  <span class="badge bg-info ms-1">{{ conteoObsMasivo.gd }}</span>
                </a>
              </li>
              <li class="nav-item" v-if="tabsDisponiblesMasivo.am">
                <a class="nav-link" :class="{ active: modalMasivoTab === 'am' }" href="#" @click.prevent="modalMasivoTab = 'am'">
                  <span class="fw-bold text-warning">AM</span>&nbsp; Auditoría Médica
                  <span class="badge bg-warning text-dark ms-1">{{ conteoObsMasivo.am }}</span>
                </a>
              </li>
              <li class="nav-item" v-if="tabsDisponiblesMasivo.ct">
                <a class="nav-link" :class="{ active: modalMasivoTab === 'ct' }" href="#" @click.prevent="modalMasivoTab = 'ct'">
                  <span class="fw-bold text-success">CT</span>&nbsp; Control de Tarifas
                  <span class="badge bg-success ms-1">{{ conteoObsMasivo.ct }}</span>
                </a>
              </li>
            </ul>

            <div v-if="modalMasivoTab === 'gd'" class="mb-3">
              <label class="form-label fw-bold text-info">
                Respuesta GD — se aplicará a {{ conteoObsMasivo.gd }} registro(s) con obs. GD
              </label>
              <textarea v-model="modalMasivoForm.respuestaGD" class="form-control" rows="5" style="text-transform: uppercase"></textarea>
            </div>
            <div v-if="modalMasivoTab === 'am'" class="mb-3">
              <label class="form-label fw-bold text-warning">
                Respuesta AM — se aplicará a {{ conteoObsMasivo.am }} registro(s) con obs. AM
              </label>
              <textarea v-model="modalMasivoForm.respuestaAM" class="form-control" rows="5" style="text-transform: uppercase"></textarea>
            </div>
            <div v-if="modalMasivoTab === 'ct'" class="mb-3">
              <label class="form-label fw-bold text-success">
                Respuesta CT — se aplicará a {{ conteoObsMasivo.ct }} registro(s) con obs. CT
              </label>
              <textarea v-model="modalMasivoForm.respuestaCT" class="form-control" rows="5" style="text-transform: uppercase"></textarea>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-secondary btn-sm" @click="cerrarModalMasivo">Cancelar</button>
            <button type="button" class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                    @click="guardarRespuestaMasiva" :disabled="guardandoMasivo">
              <span class="material-icons" style="font-size:16px">save</span>
              {{ guardandoMasivo ? 'Guardando...' : 'Guardar para todos' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const tieneObservaciones = (r) =>
  r.obsCodificadaGD || r.obsComplementariaGD ||
  r.obsCodificadaAM || r.obsComplementariaAM ||
  r.obsCodificadaCT || r.obsComplementariaCT;

const pendienteRespuesta = (r) => {
  const gdPendiente = (r.obsCodificadaGD || r.obsComplementariaGD) && !r.respuestaGD;
  const amPendiente = (r.obsCodificadaAM || r.obsComplementariaAM) && !r.respuestaAM;
  const ctPendiente = (r.obsCodificadaCT || r.obsComplementariaCT) && !r.respuestaCT;
  return Boolean(gdPendiente || amPendiente || ctPendiente || !r.resolucion);
};

// Aplica filtro de estado de respuesta: '' | 'con' | 'sin'
const aplicarEstadoResp = (lista, campo, estado) => {
  if (!estado) return lista;
  return lista.filter(r =>
    estado === 'con' ? !!r[campo] : !r[campo]
  );
};

// Extrae valores únicos y ordenados de un array de objetos para un campo dado
const valoresUnicos = (arr, campo) =>
  [...new Set(arr.map(r => r[campo]).filter(Boolean))].sort();

export default {
  name: "ObservacionesCodificadas",
  components: { Layout, Footer },

  props: {
    p_idtramite:     { type: Number, required: true },
    p_idservicio:    { type: Number, required: true },
    p_estadoTramite: { type: String, required: true },
  },

  data() {
    return {
      cargando:  false,
      activeTab: "planilla",
      planillas: [],
      dets:      [],

      // Planilla
      paginaPla:       1,
      itemsPerPagePla: 10,
      filtroPla:       "",
      filtrosPla: {
        numero: "", cedula: "", nombre: "",
        diag1: "", diag2: "",
        resolucion: "",
        obsCodGD: "", obsCompGD: "",
        obsCodAM: "", obsCompAM: "",
        obsCodCT: "", obsCompCT: "",
        respuestaGD: "", estadoRespGD: "",
        respuestaAM: "", estadoRespAM: "",
        respuestaCT: "", estadoRespCT: "",
      },
      campoPla: "numero",
      ascPla:   true,

      // Detalle
      paginaDet:       1,
      itemsPerPageDet: 10,
      filtroDet:       "",
      filtrosDet: {
        numeroInt: "", cedula: "", nombre: "",
        codigo: "", elementoNombre: "",
        resolucion: "",
        obsCodGD: "", obsCompGD: "",
        obsCodAM: "", obsCompAM: "",
        obsCodCT: "", obsCompCT: "",
        respuestaGD: "", estadoRespGD: "",
        respuestaAM: "", estadoRespAM: "",
        respuestaCT: "", estadoRespCT: "",
      },
      campoDet: "numeroInt",
      ascDet:   true,

      // Modal respuesta individual
      modalVisible: false,
      modalTipo:    "",
      modalDato:    {},
      modalTab:     "gd",
      modalForm: {
        respuestaGD: "", respuestaAM: "", respuestaCT: "",
        obsCodificadaGD: "", obsCodificadaAM: "", obsCodificadaCT: "",
        obsComplementariaGD: "", obsComplementariaAM: "", obsComplementariaCT: "",
        resolucion: false,
      },
      guardando:         false,
      datosTramite:      "",
      soloPendientesPla: false,
      soloPendientesDet: false,

      // Selección múltiple
      seleccionadosPla: [],
      seleccionadosDet: [],

      // Modal respuesta masiva
      modalMasivoVisible: false,
      modalMasivoTipo:    "",
      modalMasivoTab:     "gd",
      modalMasivoForm: {
        respuestaGD: "", respuestaAM: "", respuestaCT: "",
        resolucion: false,
      },
      guardandoMasivo: false,
    };
  },

  computed: {
    // ── Valores únicos para selects de diagnóstico (planilla) ──
    diagsPla1() {
      return valoresUnicos(this.planillas.filter(tieneObservaciones), 'diag1');
    },
    diagsPla2() {
      return valoresUnicos(this.planillas.filter(tieneObservaciones), 'diag2');
    },
    // ── Valores únicos para select de código (detalle) ──
    codigosDet() {
      return valoresUnicos(this.dets.filter(tieneObservaciones), 'elementoCodigo');
    },

    // ── Valores únicos para selects/datalists de observaciones (planilla) ──
    opcionesObsPla() {
      const base = this.planillas.filter(tieneObservaciones);
      return {
        obsCodGD:  valoresUnicos(base, 'obsCodificadaGD'),
        obsCompGD: valoresUnicos(base, 'obsComplementariaGD'),
        obsCodAM:  valoresUnicos(base, 'obsCodificadaAM'),
        obsCompAM: valoresUnicos(base, 'obsComplementariaAM'),
        obsCodCT:  valoresUnicos(base, 'obsCodificadaCT'),
        obsCompCT: valoresUnicos(base, 'obsComplementariaCT'),
      };
    },
    // ── Valores únicos para selects/datalists de observaciones (detalle) ──
    opcionesObsDet() {
      const base = this.dets.filter(tieneObservaciones);
      return {
        obsCodGD:  valoresUnicos(base, 'obsCodificadaGD'),
        obsCompGD: valoresUnicos(base, 'obsComplementariaGD'),
        obsCodAM:  valoresUnicos(base, 'obsCodificadaAM'),
        obsCompAM: valoresUnicos(base, 'obsComplementariaAM'),
        obsCodCT:  valoresUnicos(base, 'obsCodificadaCT'),
        obsCompCT: valoresUnicos(base, 'obsComplementariaCT'),
      };
    },

    // ── Planillas filtradas y ordenadas ──
    planillasFiltradas() {
      const f = this.filtrosPla;
      const q = this.filtroPla.toLowerCase();
      let lista = this.planillas
        .filter(tieneObservaciones)
        .filter(r => !this.soloPendientesPla || pendienteRespuesta(r))
        .filter(r => {
          const global = !q || [
            r.numero, r.cedula, r.nombre, r.diag1, r.diag2,
            r.obsCodificadaGD, r.obsComplementariaGD,
            r.obsCodificadaAM, r.obsComplementariaAM,
            r.obsCodificadaCT, r.obsComplementariaCT,
          ].some(v => String(v ?? "").toLowerCase().includes(q));
          const col =
            (!f.numero    || String(r.numero  ?? "").toLowerCase().includes(f.numero.toLowerCase()))   &&
            (!f.cedula    || String(r.cedula  ?? "").toLowerCase().includes(f.cedula.toLowerCase()))   &&
            (!f.nombre    || String(r.nombre  ?? "").toLowerCase().includes(f.nombre.toLowerCase()))   &&
            (!f.diag1     || String(r.diag1   ?? "") === f.diag1)  &&
            (!f.diag2     || String(r.diag2   ?? "") === f.diag2)  &&
            // Codificadas: coincidencia exacta (select)
            (!f.obsCodGD  || String(r.obsCodificadaGD ?? "") === f.obsCodGD)  &&
            (!f.obsCodAM  || String(r.obsCodificadaAM ?? "") === f.obsCodAM)  &&
            (!f.obsCodCT  || String(r.obsCodificadaCT ?? "") === f.obsCodCT)  &&
            // Complementarias: coincidencia parcial (input + datalist)
            (!f.obsCompGD || String(r.obsComplementariaGD ?? "").toLowerCase().includes(f.obsCompGD.toLowerCase())) &&
            (!f.obsCompAM || String(r.obsComplementariaAM ?? "").toLowerCase().includes(f.obsCompAM.toLowerCase())) &&
            (!f.obsCompCT || String(r.obsComplementariaCT ?? "").toLowerCase().includes(f.obsCompCT.toLowerCase())) &&
            (!f.resolucion   || String(r.resolucion  ?? "") === f.resolucion) &&
            (!f.respuestaGD  || String(r.respuestaGD ?? "").toLowerCase().includes(f.respuestaGD.toLowerCase())) &&
            (!f.respuestaAM  || String(r.respuestaAM ?? "").toLowerCase().includes(f.respuestaAM.toLowerCase())) &&
            (!f.respuestaCT  || String(r.respuestaCT ?? "").toLowerCase().includes(f.respuestaCT.toLowerCase()));
          return global && col;
        });
      lista = aplicarEstadoResp(lista, 'respuestaGD', f.estadoRespGD);
      lista = aplicarEstadoResp(lista, 'respuestaAM', f.estadoRespAM);
      lista = aplicarEstadoResp(lista, 'respuestaCT', f.estadoRespCT);
      return this._sort(lista, this.campoPla, this.ascPla);
    },
    totalPagesPla() {
      return Math.max(1, Math.ceil(this.planillasFiltradas.length / this.itemsPerPagePla));
    },
    pagedPla() {
      const s = (this.paginaPla - 1) * this.itemsPerPagePla;
      return this.planillasFiltradas.slice(s, s + this.itemsPerPagePla);
    },

    // ── Detalles filtrados y ordenados ──
    detsFiltrados() {
      const f = this.filtrosDet;
      const q = this.filtroDet.toLowerCase();
      let lista = this.dets
        .filter(tieneObservaciones)
        .filter(r => !this.soloPendientesDet || pendienteRespuesta(r))
        .filter(r => {
          const global = !q || [
            r.numeroInt, r.planillaCedula, r.planillaNombre, r.elementoCodigo,
            r.obsCodificadaGD, r.obsComplementariaGD,
            r.obsCodificadaAM, r.obsComplementariaAM,
            r.obsCodificadaCT, r.obsComplementariaCT,
          ].some(v => String(v ?? "").toLowerCase().includes(q));
          const col =
            (!f.numeroInt     || String(r.numeroInt      ?? "").toLowerCase().includes(f.numeroInt.toLowerCase())) &&
            (!f.cedula        || String(r.planillaCedula ?? "").toLowerCase().includes(f.cedula.toLowerCase()))    &&
            (!f.nombre        || String(r.planillaNombre ?? "").toLowerCase().includes(f.nombre.toLowerCase()))    &&
            (!f.codigo        || String(r.elementoCodigo ?? "") === f.codigo) &&
            (!f.elementoNombre|| String(r.elementoNombre ?? "").toLowerCase().includes(f.elementoNombre.toLowerCase())) &&
            // Codificadas: coincidencia exacta (select)
            (!f.obsCodGD      || String(r.obsCodificadaGD ?? "") === f.obsCodGD)  &&
            (!f.obsCodAM      || String(r.obsCodificadaAM ?? "") === f.obsCodAM)  &&
            (!f.obsCodCT      || String(r.obsCodificadaCT ?? "") === f.obsCodCT)  &&
            // Complementarias: coincidencia parcial (input + datalist)
            (!f.obsCompGD     || String(r.obsComplementariaGD ?? "").toLowerCase().includes(f.obsCompGD.toLowerCase())) &&
            (!f.obsCompAM     || String(r.obsComplementariaAM ?? "").toLowerCase().includes(f.obsCompAM.toLowerCase())) &&
            (!f.obsCompCT     || String(r.obsComplementariaCT ?? "").toLowerCase().includes(f.obsCompCT.toLowerCase())) &&
            (!f.resolucion    || String(r.resolucion  ?? "") === f.resolucion) &&
            (!f.respuestaGD   || String(r.respuestaGD ?? "").toLowerCase().includes(f.respuestaGD.toLowerCase())) &&
            (!f.respuestaAM   || String(r.respuestaAM ?? "").toLowerCase().includes(f.respuestaAM.toLowerCase())) &&
            (!f.respuestaCT   || String(r.respuestaCT ?? "").toLowerCase().includes(f.respuestaCT.toLowerCase()));
          return global && col;
        });
      lista = aplicarEstadoResp(lista, 'respuestaGD', f.estadoRespGD);
      lista = aplicarEstadoResp(lista, 'respuestaAM', f.estadoRespAM);
      lista = aplicarEstadoResp(lista, 'respuestaCT', f.estadoRespCT);
      return this._sort(lista, this.campoDet, this.ascDet);
    },
    totalPagesDet() {
      return Math.max(1, Math.ceil(this.detsFiltrados.length / this.itemsPerPageDet));
    },
    pagedDet() {
      const s = (this.paginaDet - 1) * this.itemsPerPageDet;
      return this.detsFiltrados.slice(s, s + this.itemsPerPageDet);
    },

    tabsDisponibles() {
      return {
        gd: this.modalDato.obsCodificadaGD || this.modalDato.obsComplementariaGD,
        am: this.modalDato.obsCodificadaAM || this.modalDato.obsComplementariaAM,
        ct: this.modalDato.obsCodificadaCT || this.modalDato.obsComplementariaCT,
      };
    },
    hayFiltrosPla() {
      return Object.values(this.filtrosPla).some(v => v !== '') || this.filtroPla !== '';
    },
    hayFiltrosDet() {
      return Object.values(this.filtrosDet).some(v => v !== '') || this.filtroDet !== '';
    },
    justificadasPla()  { return this.planillasFiltradas.filter(r => r.resolucion === 'JUSTIFICADA').length; },
    aceptadasPla()     { return this.planillasFiltradas.filter(r => r.resolucion === 'SE ACEPTA OBJECIÓN').length; },
    justificadasDet()  { return this.detsFiltrados.filter(r => r.resolucion === 'JUSTIFICADA').length; },
    aceptadasDet()     { return this.detsFiltrados.filter(r => r.resolucion === 'SE ACEPTA OBJECIÓN').length; },
    justificadasActual() { return this.activeTab === 'planilla' ? this.justificadasPla : this.justificadasDet; },
    aceptadasActual()    { return this.activeTab === 'planilla' ? this.aceptadasPla    : this.aceptadasDet;    },
    pendientesPla() { return this.planillasFiltradas.filter(pendienteRespuesta).length; },
    pendientesDet() { return this.detsFiltrados.filter(pendienteRespuesta).length; },

    // ── Filas completas correspondientes a los ids seleccionados ──
    filasSeleccionadasPla() {
      return this.planillas.filter(r => this.seleccionadosPla.includes(r.idPlanilla));
    },
    filasSeleccionadasDet() {
      return this.dets.filter(r => this.seleccionadosDet.includes(r.idPlanillaDet));
    },

    // ── Estado del checkbox "seleccionar todos" (sobre los filtrados) ──
    todosPlaFiltradosSeleccionados() {
      return this.planillasFiltradas.length > 0 &&
        this.planillasFiltradas.every(r => this.seleccionadosPla.includes(r.idPlanilla));
    },
    todosDetFiltradosSeleccionados() {
      return this.detsFiltrados.length > 0 &&
        this.detsFiltrados.every(r => this.seleccionadosDet.includes(r.idPlanillaDet));
    },

    // ── Pestañas disponibles en el modal masivo (OR entre los seleccionados) ──
    tabsDisponiblesMasivo() {
      const filas = this.modalMasivoTipo === 'planilla' ? this.filasSeleccionadasPla : this.filasSeleccionadasDet;
      return {
        gd: filas.some(r => r.obsCodificadaGD || r.obsComplementariaGD),
        am: filas.some(r => r.obsCodificadaAM || r.obsComplementariaAM),
        ct: filas.some(r => r.obsCodificadaCT || r.obsComplementariaCT),
      };
    },
    // ── Cuántos de los seleccionados tienen cada tipo de observación ──
    conteoObsMasivo() {
      const filas = this.modalMasivoTipo === 'planilla' ? this.filasSeleccionadasPla : this.filasSeleccionadasDet;
      return {
        gd: filas.filter(r => r.obsCodificadaGD || r.obsComplementariaGD).length,
        am: filas.filter(r => r.obsCodificadaAM || r.obsComplementariaAM).length,
        ct: filas.filter(r => r.obsCodificadaCT || r.obsComplementariaCT).length,
      };
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarDatos();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    tieneObservaciones,
    pendienteRespuesta,

    async cargarDatos() {
      this.cargando = true;
      try {
        const [resPla, resDet] = await Promise.all([
          api.get(`/vwplanillas/idtramite/${this.p_idtramite}`),
          api.get(`/vwplanilladets/idtramite/${this.p_idtramite}`),
        ]);
        this.planillas = Array.isArray(resPla.data) ? resPla.data : [];
        this.dets      = Array.isArray(resDet.data) ? resDet.data : [];
      } catch (e) {
        console.error("Error al cargar datos:", e);
        this.planillas = [];
        this.dets      = [];
      } finally {
        this.cargando = false;
      }
    },

    ordenarPla(campo) {
      this.ascPla   = this.campoPla === campo ? !this.ascPla : true;
      this.campoPla = campo;
      this.paginaPla = 1;
    },
    iconPla(campo) { return this.campoPla !== campo ? "⇅" : (this.ascPla ? "↑" : "↓"); },

    ordenarDet(campo) {
      this.ascDet   = this.campoDet === campo ? !this.ascDet : true;
      this.campoDet = campo;
      this.paginaDet = 1;
    },
    iconDet(campo) { return this.campoDet !== campo ? "⇅" : (this.ascDet ? "↑" : "↓"); },

    _sort(lista, campo, asc) {
      return [...lista].sort((a, b) => {
        const va = a[campo] ?? "", vb = b[campo] ?? "";
        const na = parseFloat(va), nb = parseFloat(vb);
        if (!isNaN(na) && !isNaN(nb)) return asc ? na - nb : nb - na;
        const cmp = String(va).localeCompare(String(vb), "es");
        return asc ? cmp : -cmp;
      });
    },

    paginasVisibles(actual, total) {
      const delta = 2, rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) rango.push(i);
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    abrirModal(tipo, fila) {
      this.modalTipo = tipo;
      this.modalDato = fila;
      const tabs = {
        gd: fila.obsCodificadaGD || fila.obsComplementariaGD,
        am: fila.obsCodificadaAM || fila.obsComplementariaAM,
        ct: fila.obsCodificadaCT || fila.obsComplementariaCT,
      };
      this.modalTab = tabs.gd ? "gd" : tabs.am ? "am" : "ct";
      this.modalForm = {
        respuestaGD:        fila.respuestaGD        || "",
        respuestaAM:        fila.respuestaAM        || "",
        respuestaCT:        fila.respuestaCT        || "",
        obsCodificadaGD:    fila.obsCodificadaGD    || "",
        obsCodificadaAM:    fila.obsCodificadaAM    || "",
        obsCodificadaCT:    fila.obsCodificadaCT    || "",
        obsComplementariaGD:fila.obsComplementariaGD|| "",
        obsComplementariaAM:fila.obsComplementariaAM|| "",
        obsComplementariaCT:fila.obsComplementariaCT|| "",
        resolucion: fila.resolucion === "SE ACEPTA OBJECIÓN",
      };
      this.modalVisible = true;
    },

    cerrarModal() {
      this.modalVisible = false;
      this.modalDato    = {};
      this.modalForm    = {
        respuestaGD: "", respuestaAM: "", respuestaCT: "",
        obsCodificadaGD: "", obsCodificadaAM: "", obsCodificadaCT: "",
        obsComplementariaGD: "", obsComplementariaAM: "", obsComplementariaCT: "",
        resolucion: false,
      };
    },

    async guardarRespuesta() {
      this.guardando = true;
      try {
        const esPlanilla = this.modalTipo === "planilla";
        const id         = esPlanilla ? this.modalDato.idPlanilla : this.modalDato.idPlanillaDet;
        const endpoint   = esPlanilla ? `/planillas/${id}/respuestas` : `/planilladets/${id}/respuestas`;
        const payload    = {
          respuestaGD: this.modalForm.respuestaGD || null,
          respuestaAM: this.modalForm.respuestaAM || null,
          respuestaCT: this.modalForm.respuestaCT || null,
          resolucion:  this.modalForm.resolucion ? "SE ACEPTA OBJECIÓN" : "JUSTIFICADA",
        };
        await api.put(endpoint, payload);
        const lista = esPlanilla ? this.planillas : this.dets;
        const campo = esPlanilla ? "idPlanilla"   : "idPlanillaDet";
        const item  = lista.find(r => r[campo] === id);
        if (item) Object.assign(item, payload);
        this.cerrarModal();
      } catch (e) {
        Swal.fire({ title: "Error", text: e.response?.data || "No se pudo guardar la respuesta.", icon: "error", confirmButtonText: "Cerrar" });
      } finally {
        this.guardando = false;
      }
    },

    abrirPlanilla(idPlanilla) {
      if (idPlanilla == null) return;
      const params = new URLSearchParams({
        idTramite: this.p_idtramite, idServicio: this.p_idservicio,
        estadoTramite: this.p_estadoTramite, idPlanilla, tipoConsulta: 'REPORTE',
      });
      window.open(`/planillaformpopup?${params.toString()}`, '_blank');
    },

    exportarExcelPlanillas() {
      const headers = ["N.°","Cédula","Nombre","Diag. 1","Diag. 2","Obs. GD (Cód.)","Obs. GD (Comp.)","Resp. GD","Obs. AM (Cód.)","Obs. AM (Comp.)","Resp. AM","Obs. CT (Cód.)","Obs. CT (Comp.)","Resp. CT","Resolución"];
      const filas   = this.planillasFiltradas.map(r => [r.numero,r.cedula,r.nombre,r.diag1,r.diag2,r.obsCodificadaGD,r.obsComplementariaGD,r.respuestaGD,r.obsCodificadaAM,r.obsComplementariaAM,r.respuestaAM,r.obsCodificadaCT,r.obsComplementariaCT,r.respuestaCT,r.resolucion]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...filas]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Planillas");
      XLSX.writeFile(wb, `obs_planillas_tramite_${this.p_idtramite}.xlsx`);
    },

    exportarExcelDetalles() {
      const headers = ["N.°","Cédula","Nombre","Código TPSNS","Nombre Elemento","Obs. GD (Cód.)","Obs. GD (Comp.)","Resp. GD","Obs. AM (Cód.)","Obs. AM (Comp.)","Resp. AM","Obs. CT (Cód.)","Obs. CT (Comp.)","Resp. CT","Resolución"];
      const filas   = this.detsFiltrados.map(r => [r.numeroInt,r.planillaCedula,r.planillaNombre,r.elementoCodigo,r.elementoNombre,r.obsCodificadaGD,r.obsComplementariaGD,r.respuestaGD,r.obsCodificadaAM,r.obsComplementariaAM,r.respuestaAM,r.obsCodificadaCT,r.obsComplementariaCT,r.respuestaCT,r.resolucion]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...filas]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detalles");
      XLSX.writeFile(wb, `obs_detalles_tramite_${this.p_idtramite}.xlsx`);
    },

    limpiarFiltrosPla() {
      Object.keys(this.filtrosPla).forEach(k => { this.filtrosPla[k] = ''; });
      this.filtroPla = '';
      this.paginaPla = 1;
    },
    limpiarFiltrosDet() {
      Object.keys(this.filtrosDet).forEach(k => { this.filtrosDet[k] = ''; });
      this.filtroDet = '';
      this.paginaDet = 1;
    },

    // ── Selección individual ──
    toggleSeleccionPla(id) {
      const i = this.seleccionadosPla.indexOf(id);
      if (i === -1) this.seleccionadosPla.push(id);
      else this.seleccionadosPla.splice(i, 1);
    },
    toggleSeleccionDet(id) {
      const i = this.seleccionadosDet.indexOf(id);
      if (i === -1) this.seleccionadosDet.push(id);
      else this.seleccionadosDet.splice(i, 1);
    },

    // ── Seleccionar/deseleccionar todos los filtrados ──
    toggleSeleccionarTodosPla() {
      if (this.todosPlaFiltradosSeleccionados) {
        const idsFiltrados = new Set(this.planillasFiltradas.map(r => r.idPlanilla));
        this.seleccionadosPla = this.seleccionadosPla.filter(id => !idsFiltrados.has(id));
      } else {
        const nuevos = this.planillasFiltradas.map(r => r.idPlanilla);
        this.seleccionadosPla = [...new Set([...this.seleccionadosPla, ...nuevos])];
      }
    },
    toggleSeleccionarTodosDet() {
      if (this.todosDetFiltradosSeleccionados) {
        const idsFiltrados = new Set(this.detsFiltrados.map(r => r.idPlanillaDet));
        this.seleccionadosDet = this.seleccionadosDet.filter(id => !idsFiltrados.has(id));
      } else {
        const nuevos = this.detsFiltrados.map(r => r.idPlanillaDet);
        this.seleccionadosDet = [...new Set([...this.seleccionadosDet, ...nuevos])];
      }
    },

    // ── Modal masivo ──
    abrirModalMasivo(tipo) {
      this.modalMasivoTipo = tipo;
      const filas = tipo === 'planilla' ? this.filasSeleccionadasPla : this.filasSeleccionadasDet;
      const tabs = this.tabsDisponiblesMasivoDe(filas);
      this.modalMasivoTab = tabs.gd ? 'gd' : tabs.am ? 'am' : 'ct';
      this.modalMasivoForm = { respuestaGD: "", respuestaAM: "", respuestaCT: "", resolucion: false };
      this.modalMasivoVisible = true;
    },
    tabsDisponiblesMasivoDe(filas) {
      return {
        gd: filas.some(r => r.obsCodificadaGD || r.obsComplementariaGD),
        am: filas.some(r => r.obsCodificadaAM || r.obsComplementariaAM),
        ct: filas.some(r => r.obsCodificadaCT || r.obsComplementariaCT),
      };
    },
    cerrarModalMasivo() {
      this.modalMasivoVisible = false;
      this.modalMasivoTipo    = "";
      this.modalMasivoForm    = { respuestaGD: "", respuestaAM: "", respuestaCT: "", resolucion: false };
    },

    async guardarRespuestaMasiva() {
      this.guardandoMasivo = true;
      try {
        const esPlanilla = this.modalMasivoTipo === "planilla";
        const filas   = esPlanilla ? this.filasSeleccionadasPla : this.filasSeleccionadasDet;
        const campoId = esPlanilla ? "idPlanilla" : "idPlanillaDet";
        const resolucionTexto = this.modalMasivoForm.resolucion ? "SE ACEPTA OBJECIÓN" : "JUSTIFICADA";

        const peticiones = filas.map(r => {
          const id = r[campoId];
          const endpoint = esPlanilla ? `/planillas/${id}/respuestas` : `/planilladets/${id}/respuestas`;

          // Solo se envía el texto de respuesta si el registro tiene esa observación
          // y si el usuario escribió algo en esa pestaña.
          const tieneGD = r.obsCodificadaGD || r.obsComplementariaGD;
          const tieneAM = r.obsCodificadaAM || r.obsComplementariaAM;
          const tieneCT = r.obsCodificadaCT || r.obsComplementariaCT;

          const payload = {
            respuestaGD: (tieneGD && this.modalMasivoForm.respuestaGD) ? this.modalMasivoForm.respuestaGD : r.respuestaGD || null,
            respuestaAM: (tieneAM && this.modalMasivoForm.respuestaAM) ? this.modalMasivoForm.respuestaAM : r.respuestaAM || null,
            respuestaCT: (tieneCT && this.modalMasivoForm.respuestaCT) ? this.modalMasivoForm.respuestaCT : r.respuestaCT || null,
            resolucion:  resolucionTexto,
          };

          return api.put(endpoint, payload).then(() => ({ id, payload }));
        });

        const resultados = await Promise.allSettled(peticiones);

        // Actualiza en memoria los que sí se guardaron correctamente
        const lista = esPlanilla ? this.planillas : this.dets;
        let exitosos = 0, fallidos = 0;
        resultados.forEach(res => {
          if (res.status === "fulfilled") {
            const item = lista.find(r => r[campoId] === res.value.id);
            if (item) Object.assign(item, res.value.payload);
            exitosos++;
          } else {
            fallidos++;
          }
        });

        if (esPlanilla) this.seleccionadosPla = [];
        else this.seleccionadosDet = [];

        this.cerrarModalMasivo();

        if (fallidos > 0) {
          Swal.fire({
            title: "Guardado parcial",
            text: `Se guardaron ${exitosos} de ${resultados.length} registros. ${fallidos} fallaron.`,
            icon: "warning",
            confirmButtonText: "Cerrar",
          });
        } else {
          Swal.fire({
            title: "Listo",
            text: `Se guardó la respuesta en ${exitosos} registro(s).`,
            icon: "success",
            confirmButtonText: "Cerrar",
            timer: 2000,
          });
        }
      } catch (e) {
        Swal.fire({ title: "Error", text: e.response?.data || "No se pudo guardar la respuesta masiva.", icon: "error", confirmButtonText: "Cerrar" });
      } finally {
        this.guardandoMasivo = false;
      }
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.table td, .table th { white-space: nowrap; }
.th-sort { cursor: pointer; user-select: none; white-space: nowrap; }
.th-sort:hover { background-color: #3d5166; }
.th-obs { white-space: nowrap; font-size: 0.8rem; }
thead tr:nth-child(2) th { cursor: default; font-weight: normal; padding: 4px 6px; }
thead tr:nth-child(2) th input,
thead tr:nth-child(2) th select { font-weight: normal; color: #212529; }
.modal-body textarea.form-control {
  background-color: #ffffff;
  border: 1px solid #0d6efd;
  box-shadow: 0 0 0 1px rgba(13,110,253,.15);
}
.modal-body textarea.form-control:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13,110,253,.25);
}
.modal-body .form-control-plaintext {
  background-color: #ffffff;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #dee2e6 !important;
}
</style>